export default {
  account_id_required: "帐户ID是必需的。",
  account_not_exists: "賬號無效.",
  accountIdRequired: "时域已过期！请重新登录...",
  agent_comm_rate_required: "代理佣金率是必需的。",
  agent_id_required: "代理ID是必需的。",
  alphaNumOnly: "* 只允许使用英数字",
  atLeastThreeMatchToBetParlay: "最少混合三场赛事方能下注.",
  atLeastTwoMatchToBetParlay: "最少混合两场赛事方能下注.",
  bet_amount_required: "投注金额是必需的。",
  bet_id_required: "投注ID是必需的。",
  betAmountRequired: "需要投注金额。",
  betExists: "投注已存在。",
  betLowerMin: "您的投注金额少于最低投注额。",
  betNotExists: "请下注有效的投注以参加比赛。",
  betOverMax: "您的投注金额超过最高投注额。",
  betOverMaxBet: "您的投注金额超过最高投注额。",
  betOverMaxPerMatch: "您的投注金额超过最高投注额。",
  betTypeRequired: "需要投注类型。",
  BLOCK: "账号已被封锁!",
  changeStakeMax: "由于最大限制，输入赌注金额已更改。",
  changeStakeMin: "由于最小限制，输入赌注金额已更改。",
  CLOSE: "账号已被关闭!",
  close: "账号已被关闭！ 请与您的上线联系...",
  confirmNewPasswordRequired: "* 请再次输入您的新密码",
  connectionFailed: "无法链接钱包系统。",
  containAlphaNum: "* {fname}必须包含英数字",
  "createRoomFailed-1": "创建房间失败 1。",
  "createRoomFailed-2": "创建房间失败 2。",
  "createRoomFailed-3": "创建房间失败 3。",
  credit_amount_required: "信用额是必需的。",
  currency_required: "货币是必需的。",
  currencyNotSupported: "货币不支持",
  currPasswordRequired: "* 请输入当前密码",
  dataError: "数据错误",
  debit_amount_required: "借方金额是必需的。",
  duplicate_credit_record: "重复的信用记录。",
  duplicate_debit_record: "赔率正在更新...",
  endDateRequired: "结束日期不能为空!",
  EsportsDisabled: "电子竞技游戏已禁用",
  forbiddenAccess: "禁止访问",
  FREEZE: "账号已被冻结!",
  freeze: "账号已被冻结！ 请与您的上线联系...",
  game_maintenance: "游戏正在维护中",
  incompletedRequest: "出现了一些问题...",
  insufficient_balance: "余额不足",
  invalid_password: "* 密码不正确",
  invalidBetAmount: "无效的投注金额。",
  invalidBets: "此市场不可用，请尝试其他市场。",
  invalidCurrency: "下注货币无效",
  invalidleague: "无效的联赛。",
  invalidMarketType: "提供的市场类型无效。",
  invalidMatch: "无效的比赛。",
  invalidMember: "无效的会员。",
  invalidOddsBall: "赔率正在更新...",
  invalidOperator: "无效的运营商。",
  invalidPassword: "无效的密码。",
  invalidRoom: "无效的房间。",
  invalidRoomLimit: "无效的房间限制。",
  invalidRoomPassword: "无效的PIN码。PIN码必须为6位数字。",
  invalidRoomRate: "无效的房间费率。",
  invalidRoomType: "无效的房间类型。",
  invalidRTSMatchOdds: "无效的RTS比赛赔率。",
  invalidSession: "时域已过期！请重新登录...",
  IPJoinedBefore: "IP已加入。",
  isAlpha: "* {fname}只允许使用英文字母",
  isAlphaNum: "* {fname}只允许使用英数字",
  isEmail: "* {fname}格式错误，请确认",
  isIpAddress: "{fname}仅接受有效的IPv4地址.",
  isMaxLength: "* {fname}长度需为不超過{fvalue}个字元",
  isMaxValue: "* {fname}最高需为{fvalue}",
  isMinLength: "* {fname}长度至少需为{fvalue}个字元",
  isMinValue: "* {fname}最低需为{fvalue}",
  isNumeric: "* {fname}只允许使用数字",
  isOutrightRequired: "总冠军不能为空!",
  // vuelidate
  isRequired: "* 请输入{fname}.",
  isSameAs: "* {fname}必须与{fname2}相同",
  isUrl: "{fname}仅接受URL.",
  "joinFailed-1": "加入房间失败 1。",
  "joinFailed-2": "加入房间失败 2。",
  leagueIdRequired: "联赛ID不能为空!",
  liveCasinoDisabled: "真人娱乐场已禁用",
  liveMatchNotAllowed: "不允许直播比赛。",
  //tournament
  login_id_not_exists: "登录无效，请重新登录。",
  loginFailed: "登录失败，请稍后再试...",
  loginLimit: "您登录的过于频密，请在1分钟后重试...",
  lotteryDisabled: "乐透已禁用",
  marketTypeChanged: "由于市场类型更改，投注单已被删除。<br />请重新从市场中进行选择。",
  marketTypeRequired: "市场类型是必填项。",
  master_comm_rate_required: "总代理佣金率是必需的。",
  master_id_required: "总代理ID是必需的。",
  matchDateRequired: "比赛日期是必需的。",
  matchHide: "此市场不可用，请尝试其他市场。",
  matchLowerMin: "比赛低于最小值错误。",
  matchNotActive: "此比赛不可用，请尝试其他比赛市场。",
  matchNotAllowBet: "此市场不可用，请尝试其他市场。",
  matchOverMax: "比赛超过最大值错误。",
  matchRequired: "比赛是必需的。",
  maxMatch: "最多选择{max}场比赛。",
  maxParlayTicket: "达到混合过关单注票的最高上限!",
  maxRoomLimit: "房间限制必须小于或等于30。",
  maxRoomRate: "房间费率必须小于或等于1000。",
  member_id_required: "会员ID是必需的。",
  member_wallet_not_exists: "会员钱包不存在。",
  memberExists: "会员已存在。",
  memberJoinedBefore: "您已经加入过了，请注意，公共免费房间只能加入一次。",
  minBetAmount: "最小投注金额错误。",
  MiniGameDisabled: "迷你游戏已禁用",
  minMatch: "至少选择3场比赛。",
  minRoomLimit: "房间限制必须大于或等于3。",
  minRoomRate: "房间费率必须大于或等于10。",
  new_login_id_exists: "无效昵称，请尝试设置其他昵称.",
  newPasswordRequired: "* 请输入新密码",
  nickNameRequired: "* 请输入昵称",
  noMatchSelected: "请选择至少1场比赛。",
  notSameAs: "* {fname}与{fname2}相同",
  NoUserAccessRight: "没有权限！ 请与您的上线联系...",
  oddsDisplayInvalid: "赔率显示无效.",
  oddsIsUpdating: "赔率正在更新...",
  OK: "OK",
  pageNumberRequired: "页码不能为空!",
  pageSizeRequired: "页面大小不能为空!",
  passwordRequired: "密码不能为空!",
  passwordsNotMatch: "* 密码不匹配",
  permission_denied: "权限被拒绝。",
  pointsOverLimit: "点数超过限制错误。",
  rate_required: "费率是必需的。",
  rateLowerMin: "费率低于最小值错误。",
  rateOverMax: "费率超过最大值错误。",
  requestFailed: "您的网络不稳定，请检查您的网络连接.",
  requestLimit: "您的请求次数过于频密.",
  requestPending: "请求待处理...",
  result_exists: "结果已存在。",
  room_id_required: "房间ID是必需的。",
  roomClosed: "房间已关闭。",
  roomClosedNotAllowed: "不允许关闭房间。",
  roomEnded: "房间已结束。",
  roomEndedOrCancelled: "房间已结束或已取消。",
  roomExists: "不允许创建多于1个私人房间。",
  RoomExists: "不允许创建多于1个私人房间。",
  roomFull: "房间已满。",
  roomIdRequired: "房间ID是必需的。",
  roomIsPublicFree: "房间是公共免费的。",
  roomLimitLowerMin: "房间限制低于最小值错误。",
  roomLimitOverMax: "房间限制超过最大值错误。",
  roomLimitRequired: "房间限制是必需的。",
  roomNotExists: "房间不存在。",
  roomOverMax: "房间超过最大值错误。",
  roomPasswordRequired: "PIN码是必需的。",
  roomRateRequired: "房间费率是必需的。",
  roomTypeRequired: "房间类型是必需的。",
  s_senior_comm_rate_required: "超级资深代理佣金率是必需的。",
  s_senior_id_required: "超级资深代理ID是必需的。",
  secondary_account_exists: "您的昵称已创建.",
  selectLeague: "请选择至少一个联赛",
  selectOption: "* 请选择{fname}",
  senior_comm_rate_required: "资深代理佣金率是必需的。",
  senior_id_required: "资深代理ID是必需的。",
  session_expired: "时域已过期！请重新登录...",
  session_not_exists: "时域已过期！请重新登录...",
  sessionTokenRequired: "会话令牌是必需的。",
  shareholder_comm_rate_required: "股东佣金率是必需的。",
  shareholder_id_required: "股东ID是必需的。",
  slotDisabled: "老虎机已禁用",
  sportsTypeRequired: "运动类型不能为空!",
  startDateRequired: "开始日期不能为空!",
  SUSPEND: "您的账户已改为仅查看。",
  suspend: "账号已被暂停！ 请与您的上线联系...",
  systemError: "内部系统错误.",
  tournamentDisabled: "锦标赛已停用，请联系您的上线。",
  tournamentLeagueExists: "锦标赛联赛已存在。",
  tournamentMatchExists: "锦标赛比赛已存在。",
  transfer_id_required: "转账ID是必需的。",
  unableToGetBalanceAtTheMoment: "内置服务器错误.",
  usernameRequired: "用户名不能为空!",
  workingDateRequired: "工作日不能为空!",
  matchNotStarted: "比赛尚未开始。",
  cashOutUnavailable: "无法实时兑现。",
  errorCashoutAmount: "实时兑现正在更新...",
  invalidParameter: "无效的参数。",
  startTimeRequired: "开始时间不能为空。",
  endTimeRequired: "结束时间不能为空。",
  oddsTypeIDRequired: "赔率类型不能为空。",
  commissionRequired: "佣金不能为空。",
  requestTimeRequired: "请求时间不能为空。",
  statusRequired: "状态不能为空。",
  invalidStartTime: "无效的开始时间。",
  invalidEndTime: "无效的结束时间。",
  invalidOddsTypeID: "无效的赔率类型。",
  invalidCommission: "无效的佣金。",
  invalidRequestTime: "无效的请求时间。",
  invalidStatus: "无效的状态。",
  invalidAlgoMatchInfo: "此市场已关闭，请尝试其他市场。(-101)",
  invalidAlgoSliderLeagueInfo: "无效的联赛信息。",
  invalidAlgoSliderMinutesWeight: "无效的分钟权重。",
  invalidAlgoSliderBetType: "无效的投注类型。",
  invalidRTSRunningScoreDetails: "无效的RTS运行得分详情。",
  invalidProviderGoalTimeLine: "无效的提供者目标时间线。",
  invalidSliderTimeRange: "无效的时间范围。",
  invalidMOMatchOdds: "比赛赔率正在更新...",
  invalidProviderSlider: "无效的TM信息。",
  invalidCombineBetTypeAndOddsFormat: "无效的结合投注类型和赔率格式。",
  invalidMatchInformation: "无效的比赛信息。",
  marketClose: "此市场已关闭，请尝试其他市场。",
  error: "错误",
  freeRoomNeedBet: "请下注有效的投注以解锁免费房间的访问权限。",
};